
<p class="mt-3">
    Informujemy, że w dniach 16-17 czerwca 2022 infolinia Salon Expert będzie nieczynna.
  </p>
  <p>
    Zachęcamy do pozostawienia wiadomości na  <a *ngIf="!business" routerLink="/kontakt" (click)="closeModal()">www.salonexpert.pl/kontakt</a> <a *ngIf="business" routerLink="/biznes/kontakt" (click)="closeModal()">www.salonexpert.pl/biznes/kontakt</a>. Zajmiemy się Twoją sprawą w poniedziałek 20 czerwca. Pozdrawiamy!
  </p>
  <p>Pozdrawiamy!</p>
  <div class="row justify-content-end">
    <div class="col-auto">
      <button class="btn btn-sm btn-dark"  (click)="closeModal()">zamknij</button>
    </div>
  </div>
